import React from 'react'

const Loader = () => {
  return (
    <div>
         <div className="loader">
      <div className="loader-spinner"></div>
    </div>
    </div>
  )
}

export default Loader